import React, { useState, useCallback } from 'react';
import _ from 'lodash';
import { ModalNext, ModalHeader, ModalBody, ModalFooter } from '@jutro/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { platformMessages } from 'ml-components-platform-react';

import classNames from 'classnames';
import appConfig from 'app-config';
import metadata from './PUPSelectVehiclePopup.metadata.json5';
import peStyles from './PEPUPSelectVehiclePopupComponent-modal.module.scss';
import styles from './PUPSelectVehiclePopupComponent-modal.module.scss';
import bodyStyles from './PUPselectVehiclePopupComponent.module.scss';

import { Button } from '@jutro/legacy/components';

function PUPSelectVehiclePopupComponent(props) {
    const translator = useTranslator();

    const {
        vins,
        // ModalNextProvider properties
        isOpen,
        onResolve,
        onReject,
    } = props;
    const isGPA = appConfig.portalCode === 'GPA';
    const [ selectedVin, setSelectedVin ] = useState(null);

    const handleClose = useCallback(() => {
        onReject();
    }, [onReject]);

    const handleSave = useCallback(() => {
        if(selectedVin){
            onResolve(vins[Number(selectedVin)]);
        }
        
    }, [onResolve, selectedVin, vins]);

    
    const renderCell = (item, index, property) => {
        return _.get(item, property.path);
    }
    
    const option = (row, index) => {
        return {
            code: index.toString(),
            name: ''
        }
    }

    const onRowSelect = (index) => {
        setSelectedVin(index);
    };

    const overrides = {
        selectVehicleTable: {
            data: vins
        },
        vehicle: {
            option: option,
            value: selectedVin,
            onValueChange: onRowSelect
        },
        vehicleModel: {
            renderCell: renderCell
        },
        vehicleVin: {
            renderCell: renderCell
        },
        vehicleBodyType: {
            renderCell: renderCell
        },
        vehicleTrim: {
            renderCell: renderCell
        },
        vehicleCilinders: {
            renderCell: renderCell
        },
    };

    return (
        <ModalNext
            className={isGPA ? classNames(peStyles['ml-modal-dialog']) : styles['ml-modal-dialog']}
            isOpen={isOpen}
            onRequestClose={handleClose}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
        >
            <ModalHeader
                title="Select Vehicle"
                onClose={handleClose}
                contentLayout={{
                    component: 'div',
                    componentProps: {
                        className: isGPA ? peStyles['modal-header'] : styles['modal-header']
                    }
                }}
                titleLayout={{
                    component: 'grid',
                    componentProps: {
                        className: isGPA ? peStyles['modal-title'] : styles['modal-title']
                    }
                }}
            />
            <ModalBody contentLayout={{
                component: 'div',
                componentProps: {
                    className: isGPA ? peStyles['modal-body'] : styles['modal-body']
                }
            }}
            >
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    classNameMap={bodyStyles}
                    overrideProps={overrides}
                />
            </ModalBody>
            <ModalFooter contentLayout={{
                component: 'flex',
                componentProps: {
                    className: styles['modal-footer']
                }
            }}
            >
                <Button id="actionButton" onClick={handleSave} type="filled">
                    {translator(platformMessages.mlSave)}
                </Button>
                <Button id="cancelButton" onClick={handleClose} type="outlined">
                    {translator(platformMessages.mlCancel)}
                </Button>
            </ModalFooter>
        </ModalNext>
    );

}

export default PUPSelectVehiclePopupComponent;